import styled from '@emotion/styled';
import { Box } from '@mui/material';

export const MainBox = styled(Box)`
  padding: 20px;
`;

export const PromotionsBox = styled(Box)`
  margin: 20px auto;
`;